import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    path: 'data.due_date',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change('today_plus_days')
  }
}
